import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCaretDown = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "-0.5 1 25 25",
	height: "1em",
	width: "1em",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M23.25,7.311,12.53,18.03a.749.749,0,0,1-1.06,0L.75,7.311",
		fill: "none",
		stroke: "var(--icon-color, currentColor)",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2
	})
});
export default SvgCaretDown;
